import PlayingConditionsBox from './PlayingConditionsBox';

export default PlayingConditionsBox;
